import React from "react";
import LookupBase from "./LookupBase";

export default function LookupExternalPerson(props) {
  const endpoint = "/api/external-people";
  function queryBuilder(s) {
    return `?filters%5Bname%5D%5B$containsi%5D=${encodeURIComponent(s)}
      &fields[0]=name
      &fields[1]=phoneNumber
      &fields[2]=occupation
      &populate[fotang_external][fields][0]=fotangNameCH
      &populate[fotang_external][fields][1]=fotangNamePinyin`;
  }
  function renderItem(item) {
    const parts = [];

    // 1. fotang (digabung pakai spasi dulu)
    const fotang = [item.fotangNameCH, item.fotangNamePinyin]
      .filter(Boolean)
      .join(" ");

    if (fotang) parts.push(fotang);

    // 2. phone & occupation (masuk langsung)
    if (item.phoneNumber) parts.push(item.phoneNumber);
    if (item.occupation) parts.push(item.occupation);

    // 3. final join
    const subtitle = parts.join(" | ");

    return (

      <>
        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">👥</div>
        <div>
          <div className="font-medium">{item.name}</div>
          <div className="text-xs text-gray-500">
            {subtitle} 
          </div>
        </div>
      </>
    );
  }
  return <LookupBase endpoint={endpoint} queryBuilder={queryBuilder} renderItem={renderItem} {...props} />;
}
